import React from 'react';
import { Tab } from '@eds-web/react';
import { useTranslation } from 'react-i18next';

import { StyledCompetitiveTabs } from './CompetitiveTabs.style';
import { Prizes } from '../prizes/Prizes';
import { TaxProfile } from '../payout/TaxProfile';
import { TabValue } from '../../constants/prize';
import { useTab } from '../../contexts/TabContext';

export const CompetitiveTabs: React.FC = () => {
    const { t } = useTranslation();
    const { currentTab, setCurrentTab } = useTab();
    return (
        <StyledCompetitiveTabs
            value={currentTab}
            onChange={(_tabValue) => {
                setCurrentTab(_tabValue as TabValue);
            }}
        >
            <Tab
                content={<Prizes />}
                value={TabValue.PRIZES}
                label={t('epic.esport.prizes.tab.prize')}
            />
            <Tab
                value={TabValue.TAX}
                content={<TaxProfile />}
                label={<>{t('epic.esport.prizes.tab.tax')}</>}
            />
        </StyledCompetitiveTabs>
    );
};
